import type { ReactElement, ReactNode } from 'react';

import { byRegion, type RegionVariants } from './byRegion';

/**
 * Renders the current deployment region's version of a subtree, so both
 * versions of the markup sit side by side instead of behind a conditional:
 *
 * ```tsx
 * <RegionVariant
 *   uk={<p>Call <a href="tel:02046342296">020 4634 2296</a>.</p>}
 *   canada={<p>Contact your account manager.</p>}
 * />
 * ```
 *
 * Regions without an entry get the UK version; pass `null` to render nothing.
 */
export function RegionVariant(variants: RegionVariants<ReactNode>): ReactElement {
  return <>{byRegion(variants)}</>;
}
